export const GGG_OVERVIEW_TIPS =
  'Revenue After Refund / MAU is calculated as the total of POE1 and POE2 data for the month.';
